/**
 * Accessibility Enhancements for Shopify Theme
 */

(function() {
  'use strict';

  const MAX_RETRIES = 50;
  let retryCount = 0;
  
  /**
   * Enhanced Modal and Drawer Focus Management
   */
  function enhanceModalDrawerFocus() {
    if (typeof window.Woolman === 'undefined' || !window.Woolman.ModalsAndDrawers) {
      if (retryCount++ < MAX_RETRIES) {
        setTimeout(enhanceModalDrawerFocus, 100);
      }
      return;
    }

    // avoid rerunning the function multiple times
    if (window.__enhanceModalDrawerFocusApplied) return;
    window.__enhanceModalDrawerFocusApplied = true;

    const originalShowModalOrDrawer = window.Woolman.ModalsAndDrawers.showModalOrDrawer;
    const originalCloseModalOrDrawer = window.Woolman.ModalsAndDrawers.closeModalOrDrawer;

    window.Woolman.ModalsAndDrawers.showModalOrDrawer = function(...args) {
      originalShowModalOrDrawer.call(this, ...args);
      
      const targetElement = document.getElementById(args[0]);
      if (targetElement) {
        hideBackgroundFromScreenReaders(targetElement);
      }
    };

    window.Woolman.ModalsAndDrawers.closeModalOrDrawer = function(...args) {
      showBackgroundToScreenReaders();
      originalCloseModalOrDrawer.call(this, ...args);
    };

    // Handle drawer-target buttons
    document.querySelectorAll('[data-drawer-target]').forEach((drawerButton) => {
      if (!drawerButton.hasAttribute('data-enhanced')) {
        drawerButton.addEventListener('click', (event) => {
          event.preventDefault();
          const targetId = event.currentTarget.getAttribute('data-drawer-target');
          window.Woolman.ModalsAndDrawers.showModalOrDrawer(targetId);
        });
        drawerButton.setAttribute('data-enhanced', 'true');
      }
    });
  }

  /**
   * Hide background content from screen readers when modal/drawer is open
   */
  function hideBackgroundFromScreenReaders(activeElement) {
    const elementsToHide = document.querySelectorAll('header:not(.drawer-section), main:not(.drawer-section), footer:not(.drawer-section), .shopify-section:not(.drawer-section)');
    const targetSection = activeElement?.closest('.shopify-section');
    
    requestAnimationFrame(() => {
      elementsToHide.forEach(element => {
        if (element !== activeElement && element !== targetSection) {
          element.setAttribute('aria-hidden', 'true');
          element.setAttribute('data-drawer-hidden', 'true');
        }
      });

      document.querySelectorAll('.breadcrumb').forEach((element) => {
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('data-drawer-hidden', 'true');
      });

      // Ensure drawer is visible
      activeElement.removeAttribute('aria-hidden');
    });
  }

  /**
   * Show background content to screen readers when modal/drawer is closed
   */
  function showBackgroundToScreenReaders() {
    requestAnimationFrame(() => {
      const hiddenElements = document.querySelectorAll('[data-drawer-hidden]');
      hiddenElements.forEach(element => {
        element.removeAttribute('aria-hidden');
        element.removeAttribute('data-drawer-hidden');
      });
    });
  }

  /**
   * Initialize all accessibility enhancements
   */
  function initAccessibilityEnhancements() {
    enhanceModalDrawerFocus();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessibilityEnhancements);
  } else {
    initAccessibilityEnhancements();
  }

  // Re-initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function() {
    delete window.__enhanceModalDrawerFocusApplied;
    setTimeout(initAccessibilityEnhancements, 100);
  });

  // enable re-initialization on Shopify section unload
  document.addEventListener('shopify:section:unload', function() {
    delete window.__enhanceModalDrawerFocusApplied;
  });

})();
